$('ducument').ready(function(){
  $('.product_detail-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product_detail-slider-nav',
    vertical: false,
    responsive: [
    {
      breakpoint: 801,
      settings: {
        dots: true
      }
    }
  ]
  });
  $('.product_detail-slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.product_detail-slider',
    dots: false,
    focusOnSelect: true,
    vertical: true,
    arrows: false
  });
  
  $('.cart_right_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false
  });

});
    $('body.product .hero_img img').attr('src','https://cdn.shopify.com/s/files/1/1161/9636/products/Bundle_image.png?v=1642806317');
$('div#shopify-section-product_bundle_template .product_hero .hero_img img').attr('src','https://i.ibb.co/QCKG93x/Pristine-Drains-Bundle-Image.png');
    $('section#Bundle-Review').next().next().find('img').attr('src','https://i.ibb.co/QCKG93x/Pristine-Drains-Bundle-Image.png')